'use strict';

var React = require('react');

var SvgPriceLookupMinor = function SvgPriceLookupMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 2a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2h-8zm0 4a1 1 0 0 0 0 2h4a4.977 4.977 0 0 0-.901 2.005 1.013 1.013 0 0 0-.099-.005h-3a1 1 0 1 0 0 2h3c.033 0 .066-.002.099-.005a5.002 5.002 0 0 0 7.658 3.177l2.536 2.535a1 1 0 0 0 1.414-1.414l-2.535-2.536a5 5 0 0 0-4.172-7.757h-8zm8 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
  }));
};

exports.SvgPriceLookupMinor = SvgPriceLookupMinor;
